export default (value) => value.charAt(0).toUpperCase() + value.slice(1);
